export const paiseToRupees = value => value === null || value === undefined ? "" : `${Math.floor(value/100)}.${String(value%100).padStart(2,"0")}`;
export const rupeesToPaise = value => {
  const text=String(value).trim(); if(!/^\d+(?:\.\d{1,2})?$/.test(text))throw new Error("Use a valid rupee amount with at most two decimals");
  const [whole,fraction=""]=text.split("."); return Number(whole)*100+Number((fraction+"00").slice(0,2));
};
export const formatInr = value => new Intl.NumberFormat("en-IN",{style:"currency",currency:"INR"}).format((value||0)/100);
